module.exports = __webpack_public_path__ + "84c4e5006b33694f5e66496970ca02ba.png";